import Typography from '@mui/material/Typography';
import { Message } from '../../services/MessagingService';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { getShortDateTimeFormat } from '../../utils/Dates';

interface MessageBubbleProps {
  message: Message;
  first?: boolean;
  userProfileId?: number;
  tooltipWithTimestamp?: boolean;
}

export const MessageBubble = ({ message, first, userProfileId, tooltipWithTimestamp }: MessageBubbleProps) => {
  const isOwn = message.senderId === userProfileId;

  const linkify = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', lineBreak: 'anywhere' }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <>
      {first && (
        <Box sx={{ display: 'flex', justifyContent: isOwn ? 'flex-end' : 'flex-start' }}>
          <Typography variant="caption" sx={{ my: 1 }}>
            {message.senderName}
          </Typography>
        </Box>
      )}
      <Box sx={{ width: '100%', display: 'flex', justifyContent: isOwn ? 'flex-end' : 'flex-start' }}>
        <Tooltip
          arrow
          title={tooltipWithTimestamp ? getShortDateTimeFormat(message.sentAt, true) : ''}
          placement="auto"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -5],
                  },
                },
              ],
            },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              bgcolor: '#f1f1f1',
              px: 1.25,
              py: 0.5,
              my: 0.2,
              //   borderTopLeftRadius: 15,
              //   borderTopRightRadius: 5,
              //   borderBottomRightRadius: 15,
              //   borderBottomLeftRadius: 5,
              borderRadius: 2,
              backgroundColor: isOwn ? '#d0f0ff' : '#f1f1f1',
              width: 'fit-content',
              ...(first && {
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: -9,
                  left: isOwn ? 'auto' : '5px',
                  right: isOwn ? '5px' : 'auto',
                  width: 0,
                  height: 0,
                  borderLeft: '10px solid transparent',
                  borderRight: '10px solid transparent',
                  borderBottom: '12px solid',
                  borderBottomColor: isOwn ? '#d0f0ff' : '#f1f1f1',
                },
              }),
            }}
          >
            <Typography
              variant="body2"
              gutterBottom
              sx={{
                textAlign: isOwn ? 'right' : 'left',
                whiteSpace: 'pre-line',
                lineBreak: 'anywhere',
              }}
            >
              {linkify(message.content)}
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </>
  );
};
